import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import type { StockCheck } from "./api";

/** Why a feature was refused, with the stock figures the server decided on where it gave them. */
export interface Refusal {
  message: string;
  stock?: StockCheck;
}

/**
 * A refused feature, said where it cannot be missed (M1.13).
 *
 * A modal rather than a line on the row, because the operator presses *Feature* while listening to
 * the presenter and looks at the room, not at the row — a small red sentence beside the button read
 * as nothing having happened. The figures are the ones the server decided on, so *Shopify has 15*
 * is what Shopify said a moment ago, not what the panel last heard.
 */
export function FeatureRefusal({
  refusal,
  onClose,
}: {
  refusal: Refusal | undefined;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Modal
      opened={refusal !== undefined}
      onClose={onClose}
      title={t("lots.refused.title")}
      centered
      radius="lg"
    >
      {refusal ? (
        <Stack gap="sm">
          <Text size="sm">{refusal.message}</Text>
          {refusal.stock ? (
            <Text size="xs" c="dimmed">
              {t("catalogue.stockCheck", {
                available: refusal.stock.available,
                unheld: refusal.stock.unheld,
                effective: refusal.stock.effective,
                minimum: refusal.stock.minimum,
              })}
            </Text>
          ) : null}
          <Group justify="flex-end">
            <Button onClick={onClose} data-autofocus>
              {t("lots.refused.ok")}
            </Button>
          </Group>
        </Stack>
      ) : null}
    </Modal>
  );
}
